// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import { SvgContainer } from 'common/styles/oc-styled-components';

// Other
import { colors } from 'common/styles/style-constants';

// Component
const DentalAnxietySvg = ({ height, margin, width }) => (
  <SvgContainer
    color={colors.coral}
    height={height}
    margin={margin}
    width={width}
  >
    <svg
      width="28"
      height="40"
      viewBox="0 0 28 40"
      xmlns="http://www.w3.org/2000/svg"
      role="presentation"
    >
      <path
        d="M27.886 17.77c-.253 2.518-1.625 4.57-3.565 6.296-.97 3.968-.97 6.14.78 12.785.995 3.82-13.908 3.734-13.518 1.853.718-3.44 1.722-6.21 1.596-9.614-1.137.13-3.416 1.41-4.507 1.85-3.374 1.336-4.534-1.628-5.165-8.984-.023-.235-2.21-.625-2.538-.716-.775-.218.454-3.085 1.372-4.805.32-.582.532-1.217.625-1.875C4.04 6.67 9.21.72 15.417.72c7.302.023 13.617 5.71 12.47 17.05zm-7.57-2.97c1.205 0 2.152-1.607 2.152-3.146 0-1.065-1.352-2.82-2.152-5.01-.8 2.19-2.153 3.896-2.153 5.01 0 1.54.958 3.146 2.153 3.146zm-6.6 3.918c1.204 0 2.152-1.608 2.152-3.146 0-1.066-1.352-2.82-2.152-5.01-.8 2.19-2.153 3.895-2.153 5.01 0 1.538.958 3.146 2.153 3.146z"
        fill="#FCFBFC"
        fillRule="evenodd"
      />
    </svg>
  </SvgContainer>
);
DentalAnxietySvg.propTypes = {
  height: PropTypes.string,
  margin: PropTypes.string,
  width: PropTypes.string,
};

export default DentalAnxietySvg;
